import React, { useContext, useState, useEffect } from "react";
import "./caretakerDash.scss";

//import context
import { MyContext } from "../tenantsDashContext";

//import  components
import TopSection from "../Other-Page-Components/Caretaker-Components/OverView/Mobile-and-Tablet/Top-Section-Mobile.jsx";
import TopSectionPc from "../Other-Page-Components/Caretaker-Components/OverView/Pc-and-Large-Screens/Top-Section-Pc.jsx";

//navigation
import MobileNav from "../Other-Page-Components/Caretaker-Components/OverView/Mobile-and-Tablet/Mobile-Nav.jsx";
import Navigation from "../Other-Page-Components/Caretaker-Components/OverView/Pc-and-Large-Screens/Dashboard.jsx";

import MiddleSectionOverview from "../Other-Page-Components/Caretaker-Components/OverView/Mobile-and-Tablet/Mid-section-Mobile.jsx";
import MiddleSectionPc from "../Other-Page-Components/Caretaker-Components/OverView/Pc-and-Large-Screens/Mid-section-Pc.jsx";

//right section
import RightSectionPc from "../Other-Page-Components/Caretaker-Components/OverView/Pc-and-Large-Screens/Right-Section.jsx";

//messaging components
import MobileChat from "../Other-Page-Components/Caretaker-Components/Messaging/Mobile-and-Tablet/Mid-Section.jsx";
import MessagingApp from "../Other-Page-Components/Caretaker-Components/Messaging/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

//importing profile components
import MidSectionProfile from "../Other-Page-Components/Caretaker-Components/Profile/Mobile-and-Tablet/Mid-Section-Mobile.jsx";
import MidSectionProfilePc from "../Other-Page-Components/Caretaker-Components/Profile/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

//payment components
import MidSectionPayments from "../Other-Page-Components/Caretaker-Components/Payments/Mobile-and-Tablet/Mid-Section.jsx";
import MidSectionPaymentsPc from "../Other-Page-Components/Caretaker-Components/Payments/Pc-and-Large-Screens/Mid-Section-Pc.jsx";
import MidSectionTenants from "../Other-Page-Components/Caretaker-Components/Tenants/Mobile-and-Tablet/Mid-Section-Mobile.jsx";
import MidSectionTenantsPc from "../Other-Page-Components/Caretaker-Components/Tenants/Pc-and-Large-Screens/Mid-Section-Pc.jsx";

const CaretakerDash = () => {
  const { sharedValue, setSharedValue } = useContext(MyContext);

  //  check  window size
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 1024) {
      setIsMobileScreen(true);
    } else {
      setIsMobileScreen(false);
    }
  }, []);

  // check if window size changes
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1024) {
        setIsMobileScreen(true);
      } else {
        setIsMobileScreen(false);
      }
    }
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <div className="caretaker-dashboard">
      {isMobileScreen ? (
        <>
          {sharedValue === "Overview" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MiddleSectionOverview />
            </>
          )}

          {sharedValue === "Payments" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MidSectionPayments />
            </>
          )}
          {sharedValue === "Tenants" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MidSectionTenants />
            </>
          )}

          {sharedValue === "Messages" && (
            <>
              <MobileChat
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
            </>
          )}

          {sharedValue === "Profile" && (
            <>
              <TopSection
                setSharedValue={setSharedValue}
                sharedValue={sharedValue}
              />
              <MidSectionProfile />
            </>
          )}

          <MobileNav />
        </>
      ) : (
        <>
          <div className="pc-container">
            <Navigation />
            <div className="right">
              <TopSectionPc />
              {sharedValue === "Overview" && (
                <>
                  <div className="mid-section">
                    <div className="mid-left">
                      <MiddleSectionPc />
                    </div>
                    <div className="mid-right">
                      <RightSectionPc />
                    </div>
                  </div>
                </>
              )}
              {sharedValue === "Tenants" && (
                <>
                  <MidSectionTenantsPc />
                </>
              )}
              {sharedValue === "Payments" && (
                <>
                  <MidSectionPaymentsPc />
                </>
              )}

              {sharedValue === "Messages" && (
                <>
                  <MessagingApp />
                </>
              )}

              {sharedValue === "Profile" && (
                <>
                  <MidSectionProfilePc />
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CaretakerDash;
